"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParticipantClipSortType = void 0;
var ParticipantClipSortType;
(function (ParticipantClipSortType) {
    ParticipantClipSortType["MostRecent"] = "recent";
    ParticipantClipSortType["MostShared"] = "shared";
    ParticipantClipSortType["MostViewed"] = "viewed";
})(ParticipantClipSortType = exports.ParticipantClipSortType || (exports.ParticipantClipSortType = {}));
//# sourceMappingURL=participant-clip-sort-type.js.map